module.exports = __webpack_public_path__ + "static/media/scratch_demo.949141c1.gif";